import React, { useState, useRef, useEffect } from 'react';
import _ from 'lodash';
import {
  DialogContent,
  DialogActions,
  Avatar,
  Slider,
  FormHelperText,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Cropper from 'react-easy-crop';
import { PubSub } from '../../utils/eventUtils';
import CbButton from '../Buttons/CbButton';
import { uploadImage, postInitialImage } from '../../api/ImageService';
import { manageAPIError } from '../../utils';
import useNotifications from '../../_lib/notifications/useNotifications';

interface CroppedAreaPixels {
  x: number;
  y: number;
  width: number;
  height: number;
}

// @ts-expect-error TS(2345): Argument of type '({ config }: DefaultTheme) => { ... Remove this comment to see the full error message
const useStyles = makeStyles(({ config }) => {
  return {
    wrapper: {
      fontSize: `${config.textSizes.tertia} !important`,
      textAlign: 'left !important',
      fontWeight: 'normal !important',
      display: 'flex',
      justifyContent: 'center',
    },
    flexBox: {
      display: 'flex',
      paddingTop: '1.66rem',
      justifyContent: 'space-around',
    },
    darkTheme: {
      width: 120,
      height: 120,
      borderRadius: '5px',
      backgroundColor: config.colors.darkGreyLighter,
    },
    lightTheme: {
      width: 120,
      height: 120,
      borderRadius: '5px',
      backgroundColor: config.colors.eggWhite,
      border: `1px solid ${config.colors.darkGrey3}`,
    },
    text: {
      fontSize: config.textSizes.normal,
      paddingTop: '0.833rem',
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    avatar: {
      width: 240,
      height: 240,
    },
    negitive: {
      paddingRight: 10,
      position: 'relative',
      bottom: 3.5,
    },
    positive: {
      paddingLeft: 10,
      position: 'relative',
      bottom: 3.5,
    },
  };
});

export const UploadProfilePicture = ({ data, close }: any) => {
  const notifications = useNotifications();
  const classes = useStyles();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cp, setCp] = useState<CroppedAreaPixels | null>(null);
  const [error, setError] = useState('');
  const [pic, setPic] = useState(data);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const img = useRef(null);
  const cnv = useRef(null);
  const img1 = useRef(null);
  const cnv1 = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!cp) return;

    const canvas = cnv.current;
    const image = img.current;
    const canvas1 = cnv1.current;
    const image1 = img.current;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, cp.width, cp.height);
    ctx.drawImage(
      image,
      cp.x,
      cp.y,
      cp.width,
      cp.height,
      0,
      0,
      cp.width,
      cp.height
    );

    const ctx1 = canvas1.getContext('2d');
    ctx1.clearRect(0, 0, cp.width, cp.height);
    ctx1.drawImage(
      image1,
      cp.x,
      cp.y,
      cp.width,
      cp.height,
      0,
      0,
      cp.width,
      cp.height
    );
  }, [cp]);

  const onCropChange = (cropValue: any) => {
    setCrop(cropValue);
  };

  const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
    setCp(croppedAreaPixels);
  };

  const onZoomChange = (zoomvalue: any) => {
    setZoom(zoomvalue);
  };

  const closeModal = () => {
    close();
    const imageValue = document.getElementById('icon-button-file');
    if (!_.isNull(imageValue)) {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'HTMLEleme... Remove this comment to see the full error message
      imageValue.value = '';
    }
  };

  const selectFile = () => {
    if (fileInputRef) {
      fileInputRef.current.click();
    }
  };

  const changeImage = () => {
    const bodyFormData = new FormData();
    const file = fileInputRef.current.files[0];
    bodyFormData.append('file', file);
    const { size } = file;

    if (size / 1024 / 1024 > 2) {
      setError('The file size is too big, 2MB max.');
    } else {
      setLoading(true);
      postInitialImage(bodyFormData)
        .then((resp) => {
          setZoom(1);
          setLoading(false);
          setError('');
          setPic(resp.data);
        })
        .catch((error) => {
          setLoading(false);
          setError(error.response.data);
        });
    }
  };

  const onSubmit = () => {
    const imageValue = document.getElementById('icon-button-file1');
    if (!_.isNull(imageValue)) {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'HTMLEleme... Remove this comment to see the full error message
      imageValue.value = '';
    }

    setUploadLoading(true);
    const payload = {
      zoomFactor: zoom,
      sideLength: cp?.width,
      profilePath: pic,
    };
    uploadImage({ xCoordinate: cp?.x, yCoordinate: cp?.y }, payload)
      .then(() => {
        setUploadLoading(false);
        notifications.success('Photo Uploaded Successfully!');
        close();
        PubSub.publish('profile:uploaded', true);
      })
      .catch((error) => {
        setUploadLoading(false);
        const errorMessage = manageAPIError(
          error,
          'There has been an error uploading the image. Try again'
        );

        setError(errorMessage);
      });
  };

  const canvasStyle = {
    borderRadius: '50%',
    width: 96,
    height: 96,
  };

  return (
    <>
      <DialogContent className="modal-title">
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
        <div className={classes.wrapper}>
          Please select a PNG, JPG or GIF image file with size smaller than 2MB
          to upload
          <br /> and crop to be your profile picture.
        </div>
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
        <div className={classes.flexBox}>
          <div style={{ paddingRight: '1rem' }}>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <Avatar variant="square" className={classes.avatar}>
              <Cropper
                image={pic}
                crop={crop}
                zoom={zoom}
                aspect={1}
                cropShape="round"
                restrictPosition={false}
                showGrid={false}
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                onZoomChange={onZoomChange}
              />
            </Avatar>
            <div style={{ display: 'flex' }}>
              {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
              <span className={classes.negitive}>-</span>
              <Slider
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                // @ts-expect-error TS(2769): No overload matches this call.
                classes={{ container: classes.slider }}
                // @ts-expect-error TS(2345): Argument of type 'number | number[]' is not assign... Remove this comment to see the full error message
                onChange={(e, sliderZoom) => setZoom(sliderZoom)}
              />
              {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
              <span className={classes.positive}>+</span>
            </div>
          </div>

          <div style={{ paddingRight: '1rem' }}>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <Avatar variant="square" className={classes.darkTheme}>
              <img
                ref={img1}
                id="source"
                style={{ display: 'none' }}
                src={pic}
                alt="dark profile"
              />
              <canvas
                ref={cnv1}
                id="canvas"
                width={cp?.width}
                height={cp?.height}
                style={canvasStyle}
              />
            </Avatar>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <div className={classes.text}>DARK THEME</div>
          </div>

          <div>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <Avatar variant="square" className={classes.lightTheme}>
              <img
                ref={img}
                id="source"
                style={{ display: 'none' }}
                src={pic}
                alt="light profile"
              />
              <canvas
                ref={cnv}
                id="canvas"
                width={cp?.width}
                height={cp?.height}
                style={canvasStyle}
              />
            </Avatar>
            {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
            <div className={classes.text}>LIGHT THEME</div>
          </div>
        </div>
        <FormHelperText className="api-text-error">{error}</FormHelperText>
      </DialogContent>
      <DialogActions style={{ display: 'block' }}>
        {/* @ts-expect-error TS(2339): Property 'flexBox' does not exist on type */}
        <div className={classes.buttonWrapper}>
          <div>
            <input
              accept=".png,.jpg,.jpeg,.gif"
              style={{ display: 'none' }}
              id="icon-button-file"
              type="file"
              ref={fileInputRef}
              onChange={changeImage}
            />
            <CbButton
              styleName="cancel"
              size="medium"
              onClick={selectFile}
              loading={loading}
              style={{ border: '1px solid #2180e2' }}
            >
              Change Image
            </CbButton>
          </div>

          <div>
            <CbButton styleName="cancel" size="small" onClick={closeModal}>
              Cancel
            </CbButton>
            <CbButton
              styleName="ctaButton"
              buttonText="Upload"
              loading={uploadLoading}
              onClick={onSubmit}
              size="small"
            />
          </div>
        </div>
      </DialogActions>
    </>
  );
};

export default UploadProfilePicture;

export const UploadProfilePictureConfig = {
  UploadProfilePicture: {
    component: UploadProfilePicture,
    config: {
      title: 'Upload Profile Picture',
      maxWidth: 'md',
      hideCloseButton: true,
    },
  },
};
